import { normalizePro20Response } from '@/shared/api/pro20-transform';

import type { Tag } from '../types/tag.types';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function hasContentArray(
  value: unknown,
): value is { content: unknown[] } {
  return isRecord(value) && Array.isArray(value.content);
}

export function normalizeTag(raw: unknown): Tag | null {
  if (!isRecord(raw)) {
    return null;
  }

  const branchTagId = Number(raw.branchTagId);
  if (!Number.isFinite(branchTagId)) {
    return null;
  }

  return {
    branchTagId,
    branchCode: typeof raw.branchCode === 'string' ? raw.branchCode : '',
    tagName: typeof raw.tagName === 'string' ? raw.tagName : '',
  };
}

export function normalizeTagsList(raw: unknown): Tag[] {
  const results = normalizePro20Response(raw);

  if (hasContentArray(results)) {
    return results.content
      .map((item) => normalizeTag(item))
      .filter((item): item is Tag => item !== null);
  }

  if (Array.isArray(results)) {
    return results
      .map((item) => normalizeTag(item))
      .filter((item): item is Tag => item !== null);
  }

  const single = normalizeTag(results);
  return single ? [single] : [];
}
